import BaseService from 'src/services/BaseService'
import entities from 'src/config/entities'

class AdminService extends BaseService {

  constructor () {
    super({entity: entities.ADMIN})
  }

  resetUserPassword(email) {
    return this.instance.post('/reset-user-password', {
      email
    })
  }

}

export default new AdminService()
